/**
 * Alternative approach: Mixin using utility helpers
 * This makes the business logic more testable and explicit
 */
import {
  buildAdvisorProfileUrl,
  buildWhatsappMessage,
  buildWhatsappUrl,
  getCurrentBlogUrl,
  extractFirstBlogTag
} from '~/utils/blogAdvisorHelpers';

export default {
  methods: {
    /**
     * Opens the advisor's profile page in a new window and tracks the event
     */
    showAdvisorProfile() {
      const profileUrl = buildAdvisorProfileUrl(
        this.$i18n.locale,
        process.env.ADVISOR_FRONTEND_URL,
        this.advisorId
      );
      
      window.open(profileUrl);
      
      // Event tracking
      const blogSlug = this.$route.params.slug;
      this.handleEventTracking_blogAdvisorCardProfile(
        this.$route.query.adid, 
        blogSlug, 
        this.advisorRegistrationNo
      );
    },

    /**
     * Opens WhatsApp with pre-filled message and tracks the event
     */
    openWhatsapp() {
      // Get message template
      const msgObj = this.whatsappMsg.find((item) => item.PlacementCode === 'blog-single-advisor-ad'); 
      
      // Build personalized message
      const message = buildWhatsappMessage(msgObj?.Msg, {
        advisorName: this.advisorName,
        blogUrl: getCurrentBlogUrl(),
        firstBlogCategory: extractFirstBlogTag()
      });

      // Build WhatsApp URL
      const whatsappUrl = buildWhatsappUrl(this.advisorContact, message);
      
      // Event tracking
      const blogSlug = this.$route.params.slug;
      const eventTrackingParams = this.handleEventTracking_blogAdvisorCardWhatsapp(
        this.$route.query.adid, 
        blogSlug, 
        this.advisorRegistrationNo
      );
      
      // Navigate to WhatsApp
      this.$goToURL(whatsappUrl, false, eventTrackingParams, {
        getLGMConversionId: this.getLGMConversionId,
        injectLGMConversionId: this.injectLGMConversionId
      });
    },

    /**
     * Convenience method that wraps the utility function
     * @returns {string} The text content of the first blog tag
     */
    getBlogFirstTag() {
      return extractFirstBlogTag();
    }
  }
};
